export enum TaskTypePermisson {
   taskTypeCreate = "task type: create",
   taskTypeUpdate = "task type: update",
   taskTypeDelete = "task type: delete",
   taskTypeViewPaginated = "task type: view paginated",
   taskTypeView = "task type: view",
   taskTypeCopyToSubsidiary = "task type: copy to subsidiary",
}
